module.exports = __webpack_public_path__ + "static/media/shining.b9714a6f.png";